module Meevo.Plugins.AlertsManager {

    class MarketingEmailContactHasReachedConfigComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
            '$translate'
        ];

        public params: IParams;
        public data;

        public percent: number = 50;
        public percents: number[] = [50, 60, 70, 80, 90];

        get dataForReview() {
            return [
                `${this.$translate.instant('LABEL_ALERT_MARKETING_EMAIL_CONTACT_WHEN_REACHED_PERCENT')} ${this.percent} ${this.$translate.instant('LABEL_ALERT_MARKETING_EMAIL_CONTACT_WHEN_REACHED')}`
            ];
        }

        get alertConfiguration() {
            return {
                [this.data.configKey]: this.percent
            }
        }

        constructor(protected alertsManagerService: IAlertsManagerService,
                    protected $translate: angular.translate.ITranslateService) {
            super(alertsManagerService);
        }

        onEdit(alertJSON: Object): void {
            this.percent = alertJSON[this.data.configKey];
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoMarketingEmailContactHasReachedConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/marketing-email-contact-has-reached-config/marketing-email-contact-has-reached-config.component.html',
            controller: MarketingEmailContactHasReachedConfigComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<'
            }
        });
}
